import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-feasibility-sustainability',
  templateUrl: './feasibility-sustainability.component.html',
  styleUrls: ['./feasibility-sustainability.component.css'],
})
export class FeasibilitySustainabilityComponent implements OnInit {
  // This component handles the feasibility and sustainability form for the COE application
  // It allows users to fill out the form, save it, and navigate through the application process
  feasibility: FormGroup;
  private saveApi = environment.url + 'coe/feasibility/save';
  private getApi = environment.url + 'coe/feasibility/get?id=';
  private sector = environment.url + 'dropdownvalues/get?key=focusedsectors';
  // This function initializes the form and sets up the necessary services
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.feasibility = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      applicantStrength: [''],
      reasonOfApplicant: [''],
      focusSector: [''],
      notableAchievements: [''],
      newBeneficiaries: [''],
      financialModel: [''],
    });
  }
  // This function retrieves the form controls for validation and display purposes
  ngOnInit(): void {
    this.getDataApi();
    // this.sectorApi();
  }

  showForm: boolean = false;
  get setting() {
    return this.feasibility.controls;
  }
  // This function retrieves the sector data from the API
  // It populates the dropdown list with the available sectors for the user to select
  districtdataList = ["MarineTech"];
  sectorApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi.method(this.sector, '', 'get').subscribe((data) => {
      this.getdata.amizhthLoader('hide');
      if (data.response.responseStatus == 'Success') {
        this.districtdataList = data.dropDownValues.values;
      }
    });
  }
  getValue: any = {};
  disableBtn: boolean;
  show;
  // This function retrieves the feasibility data from the API
  // It checks if the application is editable and updates the UI accordingly
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (data.responseStatus != 'Failed') {
          this.feasibility.patchValue(data);
        }
      });
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 5;
  logoCheck = false;
  fileErrorShow = false;
  fileError = false;
  // This function handles the file upload for the feasibility form
  // It checks the file size and type, and updates the UI with the uploaded file information
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.logoCheck = true;
        this.fileErrorShow = true;
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = '✔ Uploaded';
          this.fileError = false;
          this.fileErrorShow = false;
        };
      } else {
        this.notify.notifyError('Only *pdf formets are allowed');
      }
    }
  }
  // This function cancels the file upload and resets the form
  // It clears the file input and resets the form values
  cancleBtn() {
    this.fileError = true;
    this.FileValue = '';
    this.FileName = '';
    this.disName = '';
    this.fileError = true;
    this.showForm = false;
    this.feasibility.reset();
  }
  // This function prevents the Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action
    }
  }
  // This function saves the feasibility form data
  // It validates the form, sends the data to the server, and navigates to the
  saveBtn() {
    let getform = this.feasibility.value;
    if (this.feasibility.invalid) {
      this.feasibility.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      getform.applicationId = sessionStorage.getItem('applicationId');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.fileErrorShow = false;
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          this.router.navigateByUrl('admin/coe/commitments-applicant');
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
    }
  }
}
